import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_92: FaireProductEntity = {
  token: "catalog_prod_prod-92",
  type: "product",
  name: "Accent Piece",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 104.58,
  msrpDollars: 261.45,
  sku: "CA0092",
  caseSize: 12,
  material: "Metal",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 131,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_stickers-pins"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
